/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Route } from 'react-router-dom';
import { lazyLoadComponent } from '~shared/helpers/lazyLoadComponent';

const LicenseApp = lazyLoadComponent(() => import('./components/app/LicenseApp'));
const LicenseSupport = lazyLoadComponent(() => import('./components/support/LicenseSupport'));

const routes = () => (
  <>
    <Route element={<LicenseApp />} path="license/app" />
    <Route element={<LicenseSupport />} path="license/support" />
  </>
);

export default routes;
